import gql from "graphql-tag";

export const CREATE_IBKR_SSO_SESSION = gql`
  mutation CreateIBKRSSOSession($companyId: ID!) {
    createIBKRSSOSession(companyId: $companyId) {
      ssoURL
    }
  }
`;
